import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import SidebarLayout from "../../components/sidebarLayout";
import { Button, Row, Col, Form } from "react-bootstrap";
import menuData from "../../data/menuData"; // 메뉴 데이터 가져오기
import axios from "axios";
import "./jobCenterDetail.css";

export default function JobCenterDetail() {
  const jobCenterMenu = menuData.find((menu) => menu.title === "주요사업");
  const { jobCenterId } = useParams();
  const navigate = useNavigate();
  const [jobCenter, setJobCenter] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [prevJobCenter, setPrevJobCenter] = useState(null);
  const [nextJobCenter, setNextJobCenter] = useState(null);

  useEffect(() => {
    const fetchJobCenter = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `/api/jobCenter/detail/${jobCenterId}`
        );
        const data = response?.data?.data || {};
        setJobCenter(data);

        const allJobCentersResponse = await axios.get("/api/jobCenter/list");
        const allJobCenters = allJobCentersResponse?.data?.data || [];
        const currentIndex = allJobCenters.findIndex(
          (jobCenter) => jobCenter.jobCenterId === parseInt(jobCenterId, 10)
        );

        setPrevJobCenter(allJobCenters[currentIndex - 1] || null);
        setNextJobCenter(allJobCenters[currentIndex + 1] || null);
      } catch (err) {
        console.error("Error fetching jobCenter:", err);
        setError("게시물을 가져오는 중 오류가 발생했습니다.");
      } finally {
        setLoading(false);
      }
    };

    fetchJobCenter();
  }, [jobCenterId]);

  const handleDownload = () => {
    if (jobCenter?.attachmentPath) {
      window.open(jobCenter.attachmentPath, "_blank");
    } else {
      alert("첨부파일이 없습니다.");
    }
  };

  if (loading) {
    return <p className="text-center">로딩 중...</p>;
  }

  if (error) {
    return <p className="text-center text-danger">{error}</p>;
  }

  if (!jobCenter) {
    return (
      <p className="text-center text-muted">게시물이 존재하지 않습니다.</p>
    );
  }

  return (
    <div>
      <SidebarLayout menu={jobCenterMenu} subTitle={"관광 취업센터"}>
        <div className="jobCenter-detail">
          <Row className="align-items-center mb-3">
            <Col>
              <h1 className="jobCenter-title">{jobCenter.title}</h1>
            </Col>
            <Col className="text-end text-muted small">
              <p>
                작성일: {new Date(jobCenter.createdAt).toLocaleDateString()}
              </p>
            </Col>
          </Row>
          <Row className="mb-5">
            <Col>
              <div dangerouslySetInnerHTML={{ __html: jobCenter.content }} />
            </Col>
          </Row>

          {/* 첨부파일 */}
          {jobCenter.attachmentPath && (
            <Form.Group className="mb-3" controlId="formAttachment">
              <Form.Label>첨부파일</Form.Label>
              <div className="mb-2">
                <Form.Control
                  type="text"
                  value={decodeURIComponent(
                    jobCenter.attachmentPath.split("/").pop()
                  )}
                  readOnly
                />
                <Button
                  variant="outline-primary"
                  className="mt-2"
                  onClick={handleDownload}
                >
                  다운로드
                </Button>
              </div>
            </Form.Group>
          )}

          <Row className="justify-content-between mt-5">
            <Col>
              {prevJobCenter && (
                <Button
                  style={{
                    borderColor: "#1769b3",
                    color: "#1769b3",
                    backgroundColor: "transparent",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#1769b3";
                    e.target.style.color = "#ffffff";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#1769b3";
                  }}
                  onClick={() =>
                    navigate(`/jobCenter/${prevJobCenter.jobCenterId}`)
                  }
                >
                  이전 글: {prevJobCenter.title}
                </Button>
              )}
            </Col>
            <Col className="text-end">
              {nextJobCenter && (
                <Button
                  style={{
                    borderColor: "#1769b3",
                    color: "#1769b3",
                    backgroundColor: "transparent",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#1769b3";
                    e.target.style.color = "#ffffff";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#1769b3";
                  }}
                  onClick={() =>
                    navigate(`/jobCenter/${nextJobCenter.jobCenterId}`)
                  }
                >
                  다음 글: {nextJobCenter.title}
                </Button>
              )}
            </Col>
          </Row>
        </div>
      </SidebarLayout>
    </div>
  );
}
